var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d57c53794b5888d2fc26e73ffe8e0564.svg#y';
                    var viewUrl = 'sprites.d57c53794b5888d2fc26e73ffe8e0564.svg#view-y';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 35 43',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };